import { FormControl, Select, Input, MenuItem, InputLabel } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import MyModal from 'components/MyModal';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { listProducts, getAffiliates, sendMessageBroadcast } from 'store/Orbita/MessagingInternal/actions';

import styles from '../../styles/';

import type { DispatchProp } from 'react-redux';
//import SelectMultiple from 'components/SelectMultiple';

interface IProps extends DispatchProp<any> {
  classes: any;
  updateChats: any;
  closeModal: any;
  active: boolean;
  listProducts: any;
  listAffiliates: any;
}

interface IStates {
  productsNew: any;
  productsSelected: any;
  affiliatesSelected: any;
  affiliatesNew: any;
  valueAnswer: string;
  sendEmail: boolean;
  loadingNew: boolean;
}

class ModalNewChat extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      productsNew: [],
      affiliatesNew: [],
      productsSelected: [],
      affiliatesSelected: [],
      valueAnswer: '',
      sendEmail: false,
      loadingNew: false,
    };
  }

  handleClickNew = () => {
    let { productsNew, affiliatesNew, valueAnswer, sendEmail } = this.state;

    if (productsNew.length === 0 || affiliatesNew.length === 0) {
      toast.info('Selecione ao menos um produto e um afiliado');
    } else if (!valueAnswer) {
      toast.info('Escreva sua mensagem');
    } else {
      (async () => {
        try {
          this.setState({ loadingNew: true });

          await this.props.dispatch(sendMessageBroadcast(valueAnswer, affiliatesNew, sendEmail));

          toast.success('Mensagens enviadas com sucesso');
          this.setState({ loadingNew: false, productsNew: [], affiliatesNew: [], valueAnswer: '', sendEmail: false });

          this.props.updateChats();
          this.props.closeModal();
        } catch (error) {
          toast.error(error);
          this.setState({ loadingNew: false });
        }
      })();
    }
  };

  onChangeProducts = (event: React.ChangeEvent<{ value: unknown }>) => {
    this.setState({ productsNew: event.target.value }, () => {
      this.getAffiliatesByProducts();
    });
  };

  onChangeAffiliates = (event: React.ChangeEvent<{ value: unknown }>) => {
    this.setState({ affiliatesNew: event.target.value });
  };

  getAffiliatesByProducts = () => {
    let { productsNew } = this.state;

    if (productsNew.length) {
      (async () => {
        try {
          let products = [] as any;

          productsNew && productsNew.map((product: any) => products.push(product));

          await this.props.dispatch(getAffiliates(products));
          this.setState({ affiliatesSelected: this.props.listAffiliates.data });
        } catch (error) {
          toast.error(error);
        }
      })();
    }
  };

  selectAffiliates = (status: string) => {
    let { productsNew, affiliatesSelected } = this.state;
    let clearAffiliates = [] as any;
    let newAffiliates = [] as any;

    if (productsNew.length === 0) {
      toast.info('Selecione um ou mais produtos para liberar essa função');
    } else if (affiliatesSelected.length === 0) {
      toast.info('Nenhum afiliado/coprodutor encontrado');
    } else {
      switch (status) {
        case 'approved':
          clearAffiliates = affiliatesSelected.filter((affiliate: any) => {
            return affiliate.status === 'A';
          });
          break;
        case 'pending':
          clearAffiliates = affiliatesSelected.filter((affiliate: any) => {
            return affiliate.status === 'P';
          });
          break;
        case 'none':
          clearAffiliates = [];
          break;
        default:
          clearAffiliates = affiliatesSelected;
          break;
      }

      clearAffiliates.map((affiliate: any) => {
        newAffiliates.push(affiliate.id);
        return false;
      });

      this.setState({ affiliatesNew: newAffiliates });
    }
  };

  selectAllProducts = () => {
    let { productsSelected } = this.state;
    let newProducts = [] as any;

    productsSelected.map((product: any) => {
      newProducts.push(product.id);
      return false;
    });

    this.setState({ productsNew: newProducts }, () => {
      this.getAffiliatesByProducts();
    });
  };

  deSelectAllProducts = () => {
    this.setState({ productsNew: [], affiliatesSelected: [], affiliatesNew: [] }, () => {
      this.getAffiliatesByProducts();
    });
  };

  handleChangeFieldAnswer = (e: any) => {
    this.setState({ valueAnswer: e.target.value });
  };

  handleChange = (name: string) => (event: any) => {
    let newState = this.state;
    newState[name] = event.target.checked;
    this.setState(newState);
  };

  componentDidMount() {
    (async () => {
      try {
        await this.props.dispatch(listProducts());
        this.setState({ productsSelected: this.props.listProducts });
      } catch (error) {
        toast.error(error);
      }
    })();
  }

  render() {
    const { classes, closeModal, active, listAffiliates, listProducts } = this.props;
    const { productsNew, productsSelected, affiliatesSelected, affiliatesNew, valueAnswer, sendEmail, loadingNew } = this.state;

    return (
      <MyModal
        hasActive={active}
        title={'Nova mensagem'}
        closeModal={closeModal}
        textButtonOk={'Enviar'}
        hasButtons={true}
        handleClickOk={this.handleClickNew}
        loading={loadingNew}
      >
        <div className={classes.modalContent}>
          <Grid container direction='row' spacing={2}>
            <Grid item xs={12}>
              <FormControl className={classes.formControl}>
                <InputLabel id='demo-mutiple-name-label'>Produtos</InputLabel>
                <Select
                  labelId='demo-mutiple-name-label'
                  id='demo-mutiple-name'
                  multiple
                  fullWidth
                  value={productsNew}
                  onChange={this.onChangeProducts}
                  input={<Input fullWidth />}
                >
                  {productsSelected.map((product: any) => (
                    <MenuItem key={product.id} value={product.id}>
                      {product.name}
                    </MenuItem>
                  ))}
                </Select>
                <div className='m8'></div>
                <div className={classes.affiliatesActions}>
                  <div className={classes.affiliatesActionsItems} onClick={this.selectAllProducts}>
                    Selecionar todos produtos
                  </div>
                  {productsNew && productsNew.length > 0 && (
                    <div className={classes.affiliatesActionsItems} onClick={this.deSelectAllProducts}>
                      Remover todos produtos
                    </div>
                  )}
                </div>
              </FormControl>
            </Grid>
            {productsNew && productsNew.length > 0 && affiliatesSelected && affiliatesSelected.length > 0 ? (
              <Grid item xs={12}>
                <FormControl className={classes.formControl}>
                  <InputLabel id='demo-mutiple-name-label2'>Afiliados</InputLabel>
                  <Select
                    labelId='demo-mutiple-name-label2'
                    id='demo-mutiple-name2'
                    multiple
                    fullWidth
                    value={affiliatesNew}
                    onChange={this.onChangeAffiliates}
                    input={<Input fullWidth />}
                  >
                    {affiliatesSelected.map((affiliate: any) => (
                      <MenuItem key={affiliate.id} value={affiliate.id}>
                        {affiliate.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <div className='m8'></div>
                  {productsNew && productsNew.length > 0 && (
                    <div className={classes.affiliatesActions}>
                      <div className={classes.affiliatesActionsItems} onClick={() => this.selectAffiliates('approved')}>
                        Selecionar aprovados
                      </div>
                      <div className={classes.affiliatesActionsItems} onClick={() => this.selectAffiliates('pending')}>
                        Selecionar pendentes
                      </div>
                      <div className={classes.affiliatesActionsItems} onClick={() => this.selectAffiliates('all')}>
                        Selecionar todos
                      </div>
                      {affiliatesNew && affiliatesNew.length > 0 && (
                        <div className={classes.affiliatesActionsItems} onClick={() => this.selectAffiliates('none')}>
                          Remover todos afiliados
                        </div>
                      )}
                    </div>
                  )}
                </FormControl>
              </Grid>
            ) : (listAffiliates && listAffiliates.isFetching) || (listProducts && listProducts.isFetching) ? (
              <Grid item xs={12}>
                <span>Carregando afiliados...</span>
              </Grid>
            ) : productsNew && productsNew.length > 0 ? (
              <Grid item xs={12}>
                <span>Não foi encontrado nenhum afiliado para o(s) produto(s) selecionado(s).</span>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <span>Selecione pelo menos 1 produto para carregar os afiliados</span>
              </Grid>
            )}
            <Grid item xs={12}>
              <label>Mensagem</label>
              <div className='m4'></div>
              <textarea
                className={classes.textarea}
                placeholder='Escreva sua mensagem...'
                onChange={this.handleChangeFieldAnswer}
                value={valueAnswer}
                disabled={productsNew.length === 0 || affiliatesNew.length === 0}
              ></textarea>
              <Checkbox
                checked={sendEmail}
                onChange={this.handleChange('sendEmail')}
                value='send-email'
                color='primary'
                style={{ padding: 0, width: 32, height: 32 }}
              />{' '}
              <span style={{ fontSize: 13 }}>Enviar cópia por e-mail</span>
            </Grid>
          </Grid>
        </div>
      </MyModal>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    listProducts: state.orbita.Messages.listProducts,
    listAffiliates: state.orbita.Messages.getAffiliates,
  };
}

export default connect(mapStateToProps)(styles(ModalNewChat));
